import React from "react";
import { Input } from "reactstrap";

const TableSelection = ({ tables, tableNumber, setTableNumber, bgColor }) => {
  const availableTables = tables;

  return (
    <div
      className="my-2 px-3 py-2 rounded d-flex align-items-center justify-content-between gap-3 table__search-box"
      style={{
        height: "55px",
        maxHeight: "55px",
        border: "1px solid rgba(135, 135, 135, 0.24)",
        borderRadius: "10px",
      }}
    >
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ width: "40px", flexShrink: 0 }}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_811_22218"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <g clipPath="url(#clip0_811_22218)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.3808 3.23749L21.8808 7.40416C21.9588 7.53376 22 7.68211 22 7.83333C22.0018 8.4775 21.8165 9.10832 21.4666 9.64921C21.1167 10.1901 20.6174 10.6178 20.0291 10.8803C19.4409 11.1428 18.7891 11.2289 18.1528 11.1281C17.5166 11.0273 16.9233 10.744 16.445 10.3125C15.8357 10.8641 15.0432 11.1696 14.2213 11.1696C13.3994 11.1696 12.6068 10.8641 11.9975 10.3125C11.3885 10.8629 10.5968 11.1677 9.77584 11.1677C8.95491 11.1677 8.16321 10.8629 7.55417 10.3125C6.94336 10.8643 6.14896 11.1688 5.32584 11.1667H5.31917C4.4371 11.1645 3.59199 10.8121 2.9696 10.1871C2.3472 9.562 1.99846 8.7154 2.00001 7.83333C2.00005 7.68211 2.04125 7.53376 2.11917 7.40416L4.61917 3.23749C4.69323 3.11424 4.79791 3.01224 4.92306 2.94141C5.0482 2.87059 5.18954 2.83336 5.33334 2.83333H18.6667C18.8105 2.83336 18.9518 2.87059 19.077 2.94141C19.2021 3.01224 19.3068 3.11424 19.3808 3.23749ZM16.4475 12.31C17.1412 12.6548 17.9054 12.8339 18.68 12.8333C18.955 12.8297 19.2293 12.8035 19.5 12.755V21.1667C19.5 21.3877 19.4122 21.5996 19.2559 21.7559C19.0996 21.9122 18.8877 22 18.6667 22H13.6667V17H10.3333V22H5.33333C5.11232 22 4.90036 21.9122 4.74408 21.7559C4.5878 21.5996 4.5 21.3877 4.5 21.1667V12.7583C4.7728 12.8056 5.04898 12.8307 5.32583 12.8333C6.09892 12.8346 6.86174 12.6563 7.55417 12.3125C7.75887 12.4139 7.97018 12.5013 8.18667 12.5742C8.80604 12.7847 9.46101 12.8704 10.1137 12.8262C10.7664 12.782 11.4038 12.6088 11.9892 12.3167L11.9983 12.3125C12.2033 12.4139 12.4149 12.5013 12.6317 12.5742C13.2513 12.7843 13.9064 12.8696 14.5592 12.8252C15.2119 12.7809 15.8495 12.6078 16.435 12.3158L16.4475 12.31Z"
                fill="#1A94FF"
              />
            </g>
          </mask>
          <g mask="url(#mask0_811_22218)">
            <rect width="24" height="24" fill={bgColor} />
          </g>
          <defs>
            <clipPath id="clip0_811_22218">
              <rect
                width="20"
                height="20"
                fill="white"
                transform="translate(2 2)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>

      <div className="flex-grow-1 text-start">
        <Input
          type="select"
          className="fs--16 fw--600 border-0 text-dark"
          value={tableNumber}
          onChange={(e) => setTableNumber(e.target.value)}
        >
          {availableTables?.length > 0 ? (
            <option value="" style={{ color: "#000" }}>
              Select Table
            </option>
          ) : (
            <option value="" disabled style={{ color: "#000" }}>
              No Table Available
            </option>
          )}

          {availableTables?.map((table) => (
            <option
              key={table.id}
              value={table.tableNo}
              style={{ color: "#000" }}
            >
              Table {table.tableNo}
            </option>
          ))}
        </Input>
      </div>
    </div>
  );
};

export default TableSelection;
